module.exports = {
        srcSet: __webpack_public_path__ + "static/media/movingVehicleMobile-166.318056d1.webp"+" 166w",
        images: [{path: __webpack_public_path__ + "static/media/movingVehicleMobile-166.318056d1.webp",width: 166,height: 166}],
        src: __webpack_public_path__ + "static/media/movingVehicleMobile-166.318056d1.webp",
        toString: function(){return __webpack_public_path__ + "static/media/movingVehicleMobile-166.318056d1.webp"},
        
        width: 166,
        height: 166
      }